export default __webpack_public_path__ + "static/media/alert-icon-1.81cd05bf.svg";